<template>
  <section class="menus">
    <van-cell-group class="menus__list">
      <!-- to="invoice-temporary" -->
      <van-cell title="临停订单" size="large" is-link :to="{name:'Invoice-Temporary'}" />
      <!-- to="invoice-month" -->
      <van-cell title="包月订单" size="large" is-link @click="linkComponents" />
      <!-- to="invoice-history" -->
      <van-cell title="开票历史" size="large" is-link :to="{name:'Invoice-History'}" />
      <!-- to="invoice-help" -->
      <van-cell title="发票帮助" size="large" is-link :to="{name:'Invoice-Help'}" />
    </van-cell-group>
  </section>
</template>

<script>
import {
  CellGroup
} from 'vant'
export default {
  name: 'Invoice-Home',
  components: {
    [CellGroup.name]: CellGroup
  },
  data () {
    return {}
  },
  methods: {
    // 跳转
    linkComponents () {
      this.$toast('暂未开通 敬请期待！')
    }
  }
}
</script>

<style lang="scss" scoped>
.menus {
  height: 100vh;
  background: #f4f6f7;

  &__list {
    &__icon {
      font-size: 20px;
      line-height: 24px;
      margin-right: 5px;
      height: 24px;
    }
  }
}
</style>